import { FC, useState } from 'react'
import { PageTitle } from '../../../../_metronic/layout/core'
import { AvailableSellersTab } from './components/AvailableSellersTab'
import { QueueTab } from './components/QueueTab'
import { InServiceTab } from './components/InServiceTab'
import { HistoryTab } from './components/HistoryTab'
import { NoSaleReasonsTab } from './components/NoSaleReasonsTab'
import { ConfigTab } from './components/ConfigTab'
import { UsageInstructions } from './components/UsageInstructions'
import usePluginSpace from '../../../hooks/usePluginSpace'

type TabKey = 'available' | 'queue' | 'inservice' | 'history' | 'reasons' | 'config'

const SellerQueueContent: FC = () => {
  const { getPluginSpace } = usePluginSpace()
  const pluginspaceData = getPluginSpace()
  const pluginspaceId = pluginspaceData?.id || 0
  
  console.log('[SellerQueue] index - PluginSpace data:', pluginspaceData)
  console.log('[SellerQueue] index - Using pluginspaceId:', pluginspaceId)
  
  const [activeTab, setActiveTab] = useState<TabKey>('queue')
  const [refreshKey, setRefreshKey] = useState(0)

  const handleQueueChanged = () => {
    setRefreshKey((prev) => prev + 1)
  }

  const tabs: Array<{ key: TabKey; label: string; icon: string }> = [
    { key: 'available', label: 'Vendedores Disponíveis', icon: 'fas fa-users' },
    { key: 'queue', label: 'Fila Atual', icon: 'fas fa-list-ol' },
    { key: 'inservice', label: 'Em Atendimento', icon: 'fas fa-phone' },
    { key: 'history', label: 'Histórico', icon: 'fas fa-history' },
    { key: 'reasons', label: 'Motivos de Não Venda', icon: 'fas fa-chart-pie' },
    { key: 'config', label: 'Configuração', icon: 'fas fa-cog' },
  ]

  const renderTabContent = () => {
    switch (activeTab) {
      case 'available':
        return (
          <AvailableSellersTab
            key={`${activeTab}-${refreshKey}`}
            pluginspaceId={pluginspaceId}
            onSellerAdded={handleQueueChanged}
          />
        )
      case 'queue':
        return (
          <QueueTab
            key={`${activeTab}-${refreshKey}`}
            pluginspaceId={pluginspaceId}
            onQueueChanged={handleQueueChanged}
          />
        )
      case 'inservice':
        return (
          <InServiceTab
            key={`${activeTab}-${refreshKey}`}
            pluginspaceId={pluginspaceId}
          />
        )
      case 'history':
        return (
          <HistoryTab
            key={`${activeTab}-${refreshKey}`}
            pluginspaceId={pluginspaceId}
          />
        )
      case 'reasons':
        return (
          <NoSaleReasonsTab
            key={`${activeTab}-${refreshKey}`}
            pluginspaceId={pluginspaceId}
          />
        )
      case 'config':
        return (
          <ConfigTab
            key={`${activeTab}-${refreshKey}`}
            pluginspaceId={pluginspaceId}
          />
        )
      default:
        return null
    }
  }

  return (
    <div className='card'>
      <div className='card-header border-0'>
        <ul className='nav nav-tabs nav-line-tabs mb-0 flex-wrap' role='tablist'>
          {tabs.map((tab) => (
            <li className='nav-item' key={tab.key} role='presentation'>
              <button
                className={`nav-link ${activeTab === tab.key ? 'active' : ''}`}
                onClick={() => setActiveTab(tab.key)}
                type='button'
                role='tab'
                aria-selected={activeTab === tab.key}
              >
                <i className={`${tab.icon} me-2`}></i>
                {tab.label}
              </button>
            </li>
          ))}
        </ul>
      </div>

      <div className='card-body'>
        <UsageInstructions activeTab={activeTab} />
        <div className='tab-content' id='myTabContent'>
          <div
            className='tab-pane fade show active'
            id={`pane_${activeTab}`}
            role='tabpanel'
          >
            {renderTabContent()}
          </div>
        </div>
      </div>
    </div>
  )
}

const SellerQueue: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[{ title: 'Gestão de Fila', path: '/seller-queue', isActive: true }]}>
        Gestão de Fila de Vendedores
      </PageTitle>
      <SellerQueueContent />
    </>
  )
}

export { SellerQueue }
